export const SearchFilterModel = {
  collectionSeason:  new Date().getFullYear().toString(),
  tenderNo: "",
  lotNo: "",
  circleId: 0,
  disctrictId: 0,
  date: "",
  quantityDifferenceId: 0,
  paymentTypes: 0,
};
